import axios from "axios";
import Api from "../config/api/axios.urlcontext.js"

export default class RendicionDeCuentas {

    async getMenuRendicionCtas(url) {
        try {
            // console.log('getMenuRendicionCtas(url');
            const res = await axios.get(Api.APP_URL_API+url);
            return res;
        } catch (error) {
            console.error(error.message);
        }
    }
  async getFinanzasPublicasMenu(url) {
    try {
        console.log('finanzasPublicasMenu(url)');
        const res = await axios.get(Api.APP_URL_API+url);
        return res;
    } catch (error) {
        console.error(error.message);
    }
  }

  async getPresupuestoEgresosOP(url) {
    try {
        const res = await axios.get(Api.APP_URL_API+url);
        return res;
    } catch (error) {
        console.error(error.message);
    }
  }

}
